const tokens = {
  kcs: {
    symbol: 'KCS',
    projectLink: 'https://kcc.io/',
  },
  wkcs: {
    symbol: 'WKCS',
    address: {
      321: '0x4446fc4eb47f2f6586f9faab68b3498f86c07521',
      322: '0x6551358EDC7fee9ADAB1E2E49560E68a12E82d9e',
    },
    decimals: 18,
    projectLink: '',
  },
  mjt: {
    symbol: 'MJT',
    address: {
      321: '0x2cA48b4eeA5A731c2B54e7C3944DBDB87c0CFB6F',
      322: '0x208EecDBc49C137D0174B848DEf5F8cB74d6951E',
    },
    decimals: 18,
    projectLink: 'https://mojitoswap.finance/',
  },
  usdt: {
    symbol: 'USDT',
    address: {
      321: '0x0039f574ee5cc39bdd162e9a88e3eb1f111baf48',
      322: '0x67f6a7BbE0da067A747C6b2bEdF8aBBF7D6f60dc',
    },
    decimals: 18,
    projectLink: '',
  },
  usdc: {
    symbol: 'USDC',
    address: {
      321: '0x980a5AfEf3D17aD98635F6C5aebCBAedEd3c3430',
      322: '0xD6c7E27a598714c2226404Eb054e0c074C906Fc9',
    },
    decimals: 18,
    projectLink: '',
  },
  eth: {
    symbol: 'ETH',
    address: {
      321: '0xf55aF137A98607F7ED2eFEfA4cd2DfE70E4253b1',
      322: '0xF8Cb9f1D136Ff4c883320b5B4fa80048b888F459',
    },
    decimals: 18,
    projectLink: 'https://mojitoswap.finance/',
  },
  btck: {
    symbol: 'BTCK',
    address: {
      321: '0xfa93c12cd345c658bc4644d1d4e1b9615952258c',
      322: '0xf57a7eE19a628e4d475b72d6c9DD847c50636e01',
    },
    decimals: 18,
    projectLink: 'https://mojitoswap.finance/',
  },
}

export default tokens
